import * as types from './constants';

const initialState = {
  data: {
    commission_rate: '',
    domain: '',
    message: ''
  },
  getLoading: false,
  errors_api: {}
};

const actions = {
  // Get Base Commission Rate
  [types.GET_BASE_COMMISSION_RATE_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_BASE_COMMISSION_RATE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: {
        ...payload
      }
    };

    return { ...data };
  },

  [types.GET_BASE_COMMISSION_RATE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};